import { NestedIdValue } from '../features/multi-select/use-multi-select';
import i18n from '../i18n/i18n';
import { BranchType } from '../store/api/branches-api';
import { getDefaultLang, LangEnum } from './lang';

export const withAllBranches = (branches: BranchType[] | undefined, currentLang: LangEnum) => {
  const mapped =
    branches?.map((item) => ({
      id: String(item.id),
      value: item.name[currentLang] || item.name[getDefaultLang()] || '',
    })) || [];
  const withDefault = [{ id: '', value: i18n.t('Все') }, ...mapped];
  return withDefault;
};

export const getValueFromOptions = (options?: NestedIdValue[], ids?: string[] | number[]) => {
  const result: NestedIdValue[] = [];
  ids?.forEach((id) => {
    const found = options?.find((item) => String(item.id) === String(id));
    if (found) {
      result.push(found);
    }
  });
  return result;
};

export type GridTemplateType = 'xlsx' | 'csv';
export const gridTemplates: GridTemplateType[] = ['xlsx', 'csv'];
